import axios from 'axios';
import axiosRetry from 'axios-retry';

const apiUrl = process.env.VUE_APP_API_URL;

// let retryCount = 0;

function responseInterceptor(response) {
  return response.data;
}

function responseTrasnformer(body) {
  const data = JSON.parse(body);

  if (data.error) {
    throw new Error(data.body);
  }

  return data.body;
}

const instance = axios.create({
  baseURL: apiUrl,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'},
  transformResponse: [responseTrasnformer],
});

instance.interceptors.response.use(responseInterceptor, (error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger

  // Handle 401 by retrying
  // if (error.config && error.response && error.response.status === 401) {
  //   console.log('[api] Request failed by 401. Retrying in 1 sec');
  //   return new Promise((resolve, reject) => {
  //     if (retryCount >= 3) {
  //       reject(error);
  //     }

  //     retryCount += 1;
  //     setTimeout(() => {
  //       instance.request(error.config)
  //         .then((data) => {
  //           retryCount = 0;
  //           resolve(data);
  //         });
  //     }, 1000);
  //   });
  // }

  // Do something with response error
  console.error(error);
  return Promise.reject(error);
});

axiosRetry(instance, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

export default instance;
